<template>
    <span class="text-red-500 mr-1 font-bold text-base">*</span>
</template>

<script>
export default {
  name: "RequiredStar"
};
</script>